import React from 'react';
import Typography from '@material-ui/core/Typography';

import { useStyles } from './styles';

interface DetailsWithTitleProps {
  title: string;
}

export const DetailsWithTitle: React.FC<DetailsWithTitleProps> = ({ children, title }) => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h4" className={classes.title}>
        {title}
      </Typography>
      {children}
    </>
  );
};
